import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SynchronizationStatusContext } from '../../context/SynchronizationStatusContext';
import { prepareProps } from '../../utils/propUtils';
import { ItemsToSynchronizeListItem } from '../ItemsToSynchronizeListItem/ItemsToSynchronizeListItem';
import styles from './ItemsToSynchronizeList.module.css';
export type ItemsToSynchronizeListProps = ComponentProps<'div'>;
export const ItemsToSynchronizeList: FunctionComponent<ItemsToSynchronizeListProps> = React.memo(props => {
  const $ = _c(17);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  if ($[2] !== t0) {
    ({
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
  } else {
    remainingProps = $[3];
  }
  const {
    t
  } = useTranslation("record-it-components");
  const synchronizationStatus = useContext(SynchronizationStatusContext);
  let t1;
  if ($[4] !== synchronizationStatus.itemsToSynchronizeInfos.length || $[5] !== t) {
    t1 = synchronizationStatus.itemsToSynchronizeInfos.length !== 0 ? undefined : <div className={styles.allItemsSynchronized} data-testid="ItemsToSynchronizeList.allItemsSynchronized">{t("synchronization.ItemsToSynchronizeList.allItemsSynchronized")}</div>;
    $[4] = synchronizationStatus.itemsToSynchronizeInfos.length;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== synchronizationStatus.itemsToSynchronizeInfos.length || $[8] !== t) {
    t2 = synchronizationStatus.itemsToSynchronizeInfos.length === 0 ? undefined : <div className={styles.waitingForSynchronization}>{t("synchronization.ItemsToSynchronizeList.waitingForSynchronization", {
        count: synchronizationStatus.itemsToSynchronizeInfos.length
      })}</div>;
    $[7] = synchronizationStatus.itemsToSynchronizeInfos.length;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== synchronizationStatus.itemsToSynchronizeInfos) {
    t3 = synchronizationStatus.itemsToSynchronizeInfos.map(_temp);
    $[10] = synchronizationStatus.itemsToSynchronizeInfos;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== remainingProps || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <div {...remainingProps}>{t1}{t2}{t3}</div>;
    $[12] = remainingProps;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
});
function _temp(info) {
  return <ItemsToSynchronizeListItem itemToSynchronizeInfo={info} key={info.id} data-testid="ItemsToSynchronizeList.listItem" />;
}